import { useState } from "react";
import { toast } from "sonner";
import { Button } from "../../components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../../components/ui/card";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { useApi } from "../../context/ApiContext";
import { useAuth } from "../../context/AuthContext";

const PasswordUpdatePage = () => {
  const { user, refreshUser, logout } = useAuth();
  const api = useApi();
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!newPassword || !confirmPassword) {
      setError("Please fill in all fields.");
      return;
    }

    if (newPassword.length < 6) {
      setError("Password must be at least 6 characters long.");
      return;
    }

    if (newPassword !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    setLoading(true);
    try {
      await api.put(`/users/${user.id}/password`, { newPassword });
      toast.success("Password updated successfully!");
      await refreshUser();
    } catch (err) {
      console.error("Password update error:", err);
      setError(err.message || "Failed to update password. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="app-container min-h-screen bg-gradient-to-br from-yale-blue-900 to-yale-blue-700 flex items-center justify-center p-4">
      <Card className="w-full max-w-md mobile-safe-content">
        <CardHeader className="text-center">
          <div className="flex justify-center mb-4">
            <img
              src="/images/brikflow_logo_login-removebg-preview.png"
              alt="BrikFlow Logo"
              className="h-20 w-auto object-contain"
            />
          </div>
          <CardDescription>Update Your Password</CardDescription>
        </CardHeader>
        <CardContent>
          {error && (
            <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-md">
              <p className="text-sm text-red-600">{error}</p>
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <Label htmlFor="newPassword">New Password</Label>
              <Input
                id="newPassword"
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                placeholder="Enter new password"
                className="mobile-text"
                required
              />
            </div>
            <div>
              <Label htmlFor="confirmPassword">Confirm New Password</Label>
              <Input
                id="confirmPassword"
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                placeholder="Confirm new password"
                className="mobile-text"
                required
              />
            </div>
            <div className="pt-2 space-y-2">
              <Button
                type="submit"
                className="w-full bg-primary hover:bg-yale-blue-600 min-h-[48px] text-base font-medium"
                disabled={loading}
              >
                {loading ? "Updating Password..." : "Update Password"}
              </Button>
              <Button
                type="button"
                variant="ghost"
                onClick={logout}
                className="w-full min-h-[40px] text-sm text-muted-foreground hover:text-foreground"
              >
                Sign Out
              </Button>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};

export default PasswordUpdatePage;
